import { Box, Button, Circle, Link, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { Link as redirectLink } from 'react-router-dom'



export default function EmptyComponentTemplate({ name, ComponentIcon, bgColor, hoverColor, redirectAddress, method }) {
    const dispatch = useDispatch()
    return (
        <Box width={['90%', '90%', '90%', '80%']} p='2rem' flexDirection='column' justifyContent='space-between' alignItems='center' d='flex' bgColor='#efefef' borderRadius='3xl' >
            <Circle
                bg='white'
                size={['95px', '100px', '110px', "110px"]}
                mb='1rem'
                onClick = {() => dispatch(method())}
            >
                <ComponentIcon width='40px' height='40px' fill={bgColor} stroke = {bgColor} path={{ fill: bgColor }} />
            </Circle>
            <Text fontSize={['18px', '20px', '20px', '24px']} fontWeight='500' fontFamily='customBody' mb='1rem'>No {name} Found</Text>
            <Link as={redirectLink} to={redirectAddress} style={{ textDecoration: 'none' }}>
                <Button
                    bgColor={bgColor}
                    _hover={{ bg: hoverColor }}
                    color='white'
                    variant='outline'
                    padding={['0.5rem', '0.75rem', '1rem']}
                    fontWeight='700'
                    fontSize={['13px', '14px', '14px', '16px']}
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    borderRadius='lg'
                >+ Add New {name}
                </Button>
            </Link>
        </Box>
    )
}